<template>
  <div class="absolute w-full h-full top-0 left-0 bg-black-transparent flex items-center z-10">
    <div id="profile_popup"
         class="popup p-4 mx-auto bg-white flex flex-col items-center classen__rounded relative">
      <button class="self-end pr-5" @click="$emit('cancel')"><i class="fas fa-times text-3xl"></i></button>
      <div v-if="showAllUserInformation" class="userInformation flex place-content-center">
        <div class="w-full px-20">
          <p class="text-2xl font-bold mb-10">{{ getTranslation('editUser') }}</p>
          <div class="items-center text-left grid-rows-4">
            <div class="mt-5 flex w-full">
              <p class="mandatory w-1/5">{{ getTranslation('name') }}:</p>
              <input v-model="userName" type="text" class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
            </div>

            <div class="mt-5 flex">
              <p class="mandatory w-1/5">{{ getTranslation('email') }}:</p>
              <input v-model="userEmail" type="text"
                     class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
            </div>
            <div class="mt-5 flex">
              <p class="mandatory w-1/5">{{ getTranslation('language') }}:</p>
              <c-option-dropdown v-model="userLanguage" :options="languages"
                                 :selected-option.sync="userLanguage"
                                 class="m-2 w-full col-span-5"/>
            </div>
            <div class="mt-5 flex">
              <p class="mandatory w-1/5">{{ getTranslation('password') }}:</p>
              <input type="password" placeholder="************" disabled
                     class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
            </div>
            <p class="text-right pr-2 underline cursor-pointer" @click="showAllUserInformation = false">{{ getTranslation('changePassword') }}?</p>
          </div>
        </div>

        <button class="classen__button hover__button add_button_send_invite mb-5 px-3"
                @click="saveChanges()">
          <p class="leading-none">{{ getTranslation('saveChanges') }}</p>
        </button>
      </div>

      <div v-if="!showAllUserInformation" class="userInformation flex place-content-center">
        <div class="w-full px-20">
          <p class="text-2xl font-bold mb-16">{{ getTranslation('changePassword') }}</p>
          <p class="my-8 text-left">{{ getTranslation('chooseUniquePassword')}}</p>
          <div class="items-center text-left grid-rows-4">
            <div class="mt-5 flex w-full relative">
              <p class="mandatory w-2/6">{{ getTranslation('currentPassword') }}:</p>
              <input :type="currentPasswordType" v-model="currentPassword" class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
              <div class="absolute right-4 h-full flex items-center text-classen__primary" @click="currentPasswordType = changePasswordType(currentPasswordType)">
                <i class="fas fa-thin fa-eye"></i>
              </div>
            </div>

            <div class="mt-5 flex relative">
              <p class="mandatory w-2/6">{{ getTranslation('newPassword') }}:</p>
              <input :type="newPasswordType" v-model="newPassword" class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
              <div class="absolute right-4 h-full flex items-center text-classen__primary" @click="newPasswordType = changePasswordType(newPasswordType)">
                <i class="fas fa-thin fa-eye"></i>
              </div>
            </div>
            <div class="mt-5 flex relative">
              <p class="mandatory w-2/6">{{ getTranslation('repeatNewPassword') }}:</p>
              <input :type="repeatNewPasswordType" v-model="repeatPassword" type="password" class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
              <div class="absolute right-4 h-full flex items-center text-classen__primary" @click="repeatNewPasswordType = changePasswordType(repeatNewPasswordType)">
                <i class="fas fa-thin fa-eye"></i>
              </div>
            </div>
            <p class="text-red-500 mt-2">{{statusMessage}}</p>
          </div>
        </div>

        <button class="classen__button hover__button add_button_send_invite mb-5 px-3"
                @click="changePassword()">
          <p class="leading-none">{{ getTranslation('changePasswordAndLogout') }}</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OptionDropdown from "../../components/structure/OptionDropdown";
import AddUsersRegionDropdown from "../../components/structure/Users/AddUsersRegionDropdown";
import CustomCheckbox from "../../components/form/CustomCheckbox";
import getTranslation from "../../mixins/getTranslation";
import getPermissions from "../../mixins/getPermissions";
import EventBus from "../../services/EventBus";

export default {
  name: "ProfilePopup",

  components: {
    'c-option-dropdown': OptionDropdown,
    'c-region-dropdown': AddUsersRegionDropdown,
    'c-checkbox': CustomCheckbox,
  },

  mixins: [getTranslation, getPermissions],

  props: {},

  data() {
    return {
      userName: null,
      userEmail: null,
      userLanguage: {value: '', name: 'Choose a language...'},
      userPassword: null,
      currentPassword: null,
      newPassword: null,
      repeatPassword: null,
      showAllUserInformation: true,
      statusMessage: null,
      currentPasswordType: 'password',
      newPasswordType: 'password',
      repeatNewPasswordType: 'password',
    }
  },

  created() {
    this.userName = this.activeUser.name;
    this.userEmail = this.activeUser.email;
    const language = this.languages.find((lang) => lang.id === this.activeUser.languageId);
    this.userLanguage = {value: language.id, name: language.name};
  },

  computed: {
    languages() {
      return this.$dashboardStore.getters.getLanguages;
    },
  },

  methods: {
    async saveChanges() {
      try {
        await this.$dashboardStore.dispatch('updateOwnUser', {
          userId: this.activeUser.id,
          name: this.userName,
          email: this.userEmail,
          languageId: this.userLanguage.value,
        });

        this.$emit('cancel');
        window.location.reload();
      } catch (error) {
        console.warn('Something went wrong', error);
        this.statusMessage = "Unable to change the password. Please try again.";
      }
    },

    async changePassword() {
      if (!(this.currentPassword && this.newPassword && this.repeatPassword)) {
        this.statusMessage = "All fields should be filled in.";
        return;
      }

      if (this.newPassword !== this.repeatPassword) {
        this.statusMessage = "Passwords don't match.";
        return;
      }

      try {
        await this.$dashboardStore.dispatch('changePassword', {
          userId: this.activeUser.id,
          oldPassword: this.currentPassword,
          newPassword: this.newPassword,
        });

        await this.$dashboardStore.dispatch('clearAuthUser');
        EventBus.fire('signed-out-user');
        await this.$router.push({
          path: '/login',
          query: { data: 'Login with your new password'}
        });
      } catch (error) {
        console.warn('Something went wrong', error);
        this.statusMessage = "Unable to change the password. Please try again.";
      }
    },

    changePasswordType(type) {
      if (type === 'password') {
        return 'text';
      }

      return 'password';
    }
  }
}
</script>

<style scoped>
#profile_popup {
  width: 900px;
  height: 730px;
}

.userInformation {
  width: 100%;
  height: 100%;
}

.mandatory::after {
  color: #E60000;
  content: "*";
}

.add_button_send_invite {
  position: absolute;
  bottom: 0;
  width: auto;
}
</style>
